import { render, staticRenderFns } from "./ProductsPage.vue?vue&type=template&id=0ec47ed8&scoped=true&"
import script from "./ProductsPage.vue?vue&type=script&lang=js&"
export * from "./ProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsPage.vue?vue&type=style&index=0&id=0ec47ed8&prod&lang=stylus&scoped=true&"
import style1 from "./ProductsPage.vue?vue&type=style&index=1&id=0ec47ed8&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec47ed8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IntSlides: require('/var/www/pb-store/components/IntSlides.vue').default,ProductsCard: require('/var/www/pb-store/components/ProductsCard.vue').default,ModalProducts: require('/var/www/pb-store/components/ModalProducts.vue').default})
